import React from "react";
import { Table } from "react-bootstrap";
import styles from "./Table.module.sass";

const table = props => {
  return (
    <Table className={[styles.Table, props.className].join(" ")} responsive>
      <thead className={styles.tableHeader}>
        <tr>
          {props.headers.map((header, index) => (
            <th
              className={[
                header.className,
                header.emphasis && styles.emphasis,
              ].join(" ")}
              key={index}
            >
              <div className={styles.rowInfo}>
                <span className={styles.customEmphasis}>
                  {header.text}
                  {header.info}
                </span>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody className={styles.tableBody}>
        {props.rows.map((row, index) => (
          <tr key={index}>
            {Object.keys(row).map((prop, index) => (
              <td
                key={index}
                className={props.headers[index].bold ? styles.bold : ""}
              >
                {row[prop]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default table;
